import Layout from "@/components/elements/Layout";

export default function AttributionInstructions() {
  return (
    <Layout title={"Attribution Instructions"}>
      <div className='max-w-6xl px-4 mx-auto 2xl:max-w-7xl'>
        <h1 className='pt-8 text-6xl font-bold leading-tight text-white font-display'>
          Attribution Instructions
        </h1>
        <h2 className='text-white text-opacity-80'>
          Lucidity Insights Attribution Guidelines
          <br />
          Effective date: July 1st, 2022
        </h2>
        <div className='max-w-screen-xl py-8'>
          <article className='prose prose-invert pb-8 prose-img:rounded-[10px] prose-td:p-2 max-w-5xl'>
            <p>
              In accordance with the Terms of Service, you may reference the
              Content found on Lucidity Insights via the website
              www.LucidityInsights.com or our various publications, videos, and
              other digital content with proper attribution to Lucidity
              Insights. Our recommended attribution guidelines are described
              below.
              <ul>
                <li>
                  Attribution must clearly state that the Content is sourced
                  from Lucidity Insights and link to the webpage of the source
                  material on the Lucidity Insights website.
                </li>
                <li>
                  Attribution should be clearly visible to the end user and
                  placed in close proximity to the data being referenced from
                  Lucidity Insights.
                </li>
                <li>
                  Any Lucidity Insights watermarks and logos on illustrations,
                  graphs, and reports must remain, and cannot by removed or
                  cropped out.
                </li>
                <li>
                  When you are using Content from a specific entity from
                  Lucidity Insights (e.g. a person or company) you should link
                  to the associated entity page on Lucidity Insights.
                </li>
                <li>
                  When you are referencing Content from multiple Lucidity
                  Insights entities you should link to the Lucidity Insights
                  homepage (
                  <a href='https://www.lucidityinsights.com'>
                    https://www.lucidityinsights.com
                  </a>
                  ).
                </li>
              </ul>
            </p>
            <p>
              If you have any questions concerning attribution, feel free to
              contact us by e-mailing{" "}
              <a href='mailto:support@lucidityinsights.com'>
                support@lucidityinsights.com
              </a>
            </p>
          </article>
        </div>
      </div>
    </Layout>
  );
}
